import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1687977424018-a8f4394bb604?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  classic: "https://images.unsplash.com/photo-1690413994326-b6fff711b59c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sunset: "https://images.unsplash.com/photo-1654362330163-ceabe8d34fa3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  flyer: "https://customer-assets-cm19k8pv.emergentagent.net/job_62fdeda8-ab21-4c73-8f56-a1ff211ea0b1/artifacts/d13d4c0b145057d4_97c8a9d1-b507-a643-5a46-f88afcb4a55f.jpeg",
};

export const authed = async (getToken) => ({ headers: { Authorization: `Bearer ${await getToken()}` } });

export const apiError = (e) => e?.response?.data?.detail?.toString?.() || "Erreur";

export default axios;
